import { render } from "./ProfessorsView.vue?vue&type=template&id=edd23b04"
import script from "./ProfessorsView.vue?vue&type=script&lang=js"
export * from "./ProfessorsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__